<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="login-container">
    <div class="login-card">
      <img src="/logo.png" alt="Logo" class="logo mb-3" />
      <h2>Drone Mapping System</h2>
      
      <!-- New Password Setup Form -->
      <div v-if="showNewPassword">
        <form @submit.prevent="handleNewPassword">
          <div class="alert alert-info">
            Please set a new password for your first login.
          </div>
          <div class="form-group">
            <label>New Password</label>
            <input
              v-model="newPassword"
              type="password"
              class="form-control"
              required
              minlength="8"
            />
            <small class="form-text text-muted">
              8+ characters with uppercase, lowercase, and numbers
            </small>
          </div>
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
          <button type="submit" class="btn btn-primary btn-block">
            Set Password
          </button>
        </form>
      </div>

      <!-- Login Form -->
      <div v-else>
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <label>Email</label>
            <input
              v-model="username"
              type="text"
              class="form-control"
              required
            />
          </div>
          <div class="form-group">
            <label>Password</label>
            <input
              v-model="password"
              type="password"
              class="form-control"
              required
            />
          </div>
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
          <button type="submit" class="btn btn-primary btn-block">
            Login
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import auth from '../services/auth';

export default {
  name: 'Login',
  setup() {
    const router = useRouter();
    const username = ref('');
    const password = ref('');
    const error = ref('');
    const showNewPassword = ref(false);
    const newPassword = ref('');
    const tempCognitoUser = ref(null);
    const tempUserAttributes = ref(null);

    const handleLogin = async () => {
      error.value = '';
      try {
        const result = await auth.signIn(username.value, password.value);
        
        if (result.status === 'NEW_PASSWORD_REQUIRED') {
          // New password setup required
          tempCognitoUser.value = result.cognitoUser;
          tempUserAttributes.value = result.userAttributes;
          showNewPassword.value = true;
        } else {
          // Login successful
          router.push('/');
        }
      } catch (err) {
        error.value = err.message || 'Login failed';
      }
    };

    const handleNewPassword = async () => {
      error.value = '';
      try {
        await auth.completeNewPassword(
          tempCognitoUser.value,
          newPassword.value,
          tempUserAttributes.value
        );
        // Redirect to home after password setup
        router.push('/');
      } catch (err) {
        error.value = err.message || 'Failed to set password';
      }
    };

    return {
      username,
      password,
      error,
      showNewPassword,
      newPassword,
      handleLogin,
      handleNewPassword,
    };
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.login-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.login-card h2 {
  margin-bottom: 2rem;
}

.logo {
  max-width: 150px;
  height: auto;
}

.mb-3 {
  margin-bottom: 1rem;
}

.form-group {
  margin-bottom: 1rem;
  text-align: left;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.form-control {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-block {
  width: 100%;
}

.alert {
  padding: 0.75rem;
  margin-bottom: 1rem;
  border-radius: 4px;
  text-align: left;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.alert-info {
  background-color: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.text-muted {
  color: #6c757d;
}
</style>
